import { OutlinedInput } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { useExportDialog } from '../../hooks/use-export-dialog';
import { useExportNameValidation } from '../../hooks/use-export-name-validation';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportDialogEditNameProps as Props } from './types';

export const ExportDialogEditName = memo(
  ({
    className,
    defaultName,
    expandedAccordion,
    setExpandedAccordion,
  }: Props) => {
    const { setExportName, exportName } = useExportDialog({
      defaultName,
    });

    const { helperText, hasError } = useExportNameValidation(exportName);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setExportName(e.target.value);
    };

    useEffect(() => {
      if (!exportName) setExportName(defaultName || '');
    }, [defaultName, setExportName]);

    return (
      <Styled.Wrapper
        id="export-name"
        className={classnames('ExportDialogEditName', className)}
        sx={SX.root}
        title="Name"
        leftIcon="title-outlined"
        description={exportName}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
      >
        <OutlinedInput
          name="name"
          size="small"
          color="primary"
          inputProps={{ maxLength: 101 }}
          required
          fullWidth
          error={hasError}
          helperText={helperText}
          value={exportName}
          onChange={handleChange}
        />
      </Styled.Wrapper>
    );
  }
);

ExportDialogEditName.displayName = 'ExportDialogEditName';
